export default __webpack_public_path__ + "images/871538e55f8aa2f2c2ef5d02f307409b.svg";